module.exports = __webpack_public_path__ + "static/media/img-4-3b_retreat.d9ee81c2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/media/img-4-3b_retreat.mp3
// module id = 692
// module chunks = 0